@if (guides.length) {
<div class="rg">
    <div class="rg__mobile hide-desktop">
        <swiper-container
            #swiperRecommendedGuides
            class="rg-swiper"
            slides-per-view="auto"
            space-between="5"
        >
            @for (guide of guides; track guide) {
            <swiper-slide class="rg-swiper__slide">
                <app-guide-card
                    [guide]="guide"
                    (guideClick)="handleGuideClick($event)"
                ></app-guide-card>
            </swiper-slide>
            }
            <swiper-slide class="rg-swiper__slide">
                <app-see-more-card
                    route="/guides/recommended"
                ></app-see-more-card>
            </swiper-slide>
        </swiper-container>
    </div>
    <div class="rg__desktop hide-mobile">
        <div class="rg__grid">
            @for (guide of guides | slice:0:3; track guide) {
            <app-guide-card
                [guide]="guide"
                (guideClick)="handleGuideClick($event)"
            ></app-guide-card>
            }
        </div>
        <div class="rg__divider"></div>
        <a class="rg__more" routerLink="/guides/recommended">
            <img src="/assets/icons/see_more_icon.png" alt="" />
            {{ lang.data["general.see_more"] || "See more" }}
        </a>
    </div>
</div>
}
